interface Props {
  className?: string;
}

export default function VillageIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.01944 2H17.5854L21.3311 8.24275C21.5311 8.57601 21.291 9 20.9023 9H20V19H2V9H1.13554C0.746889 9 0.506833 8.57601 0.70679 8.24275L4.45244 2H6.01944ZM4 9V17H9V15H13V17H18V9H4ZM18.2524 7L16.4524 4H5.58544L3.78544 7H18.2524Z"
        fill="currentColor"
      />
      <rect x="5" y="10" width="4" height="4" fill="currentColor" />
      <rect x="13" y="10" width="4" height="4" fill="currentColor" />
      <path
        d="M7 0.6C7 0.544772 7.04477 0.5 7.1 0.5H8.9C8.95523 0.5 9 0.544772 9 0.6V2.5H7V0.6Z"
        stroke="currentColor"
      />
      <path
        d="M13 0.6C13 0.544772 13.0448 0.5 13.1 0.5H14.9C14.9552 0.5 15 0.544772 15 0.6V2.5H13V0.6Z"
        stroke="currentColor"
      />
    </svg>
  );
}
